(() => {
  const form = document.querySelector('#payment-form, #elena-payment-form');
  if (!form || form.dataset.paymentReady) return;
  const amountInput = form.querySelector('#payment-amount');
  const confirmation = form.querySelector('#payment-confirmed');
  const policyConfirmation = form.querySelector('#policy-confirmed');
  const total = form.querySelector('#payment-total');
  const error = form.querySelector('#payment-error');
  const submitButton = form.querySelector('[type="submit"]');
  if (!amountInput || !confirmation || !total || !error || !submitButton) return;
  form.dataset.paymentReady = 'true';
  let errorTarget = null;
  const checks = [confirmation, policyConfirmation].filter(Boolean);
  const sanitizeAmount = value => {
    const amount = Number(value);
    return Number.isInteger(amount) && amount >= 1 && amount <= 9999 ? amount : null;
  };
  const markInvalid = (input, invalid) => {
    input.closest('.confirmation-check')?.classList.toggle('is-invalid', invalid);
    if (invalid) {
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-errormessage', 'payment-error');
    } else {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-errormessage');
    }
  };
  const showError = (message, target) => {
    error.textContent = message;
    errorTarget = target;
    target?.focus();
  };
  checks.forEach(input => input.addEventListener('change', () => {
    if (input.checked) {
      markInvalid(input, false);
      if (errorTarget === input) {
        error.textContent = '';
        errorTarget = null;
      }
    }
  }));
  const updateTotal = () => {
    const amount = sanitizeAmount(amountInput.value);
    total.textContent = amount ? '$' + amount.toLocaleString('en-US') + ' USD' : '$0 USD';
    if (errorTarget === amountInput) {
      error.textContent = '';
      errorTarget = null;
    }
  };
  const linkedAmount = new URLSearchParams(window.location.search).get('amount');
  if (sanitizeAmount(linkedAmount)) amountInput.value = sanitizeAmount(linkedAmount);
  updateTotal();
  amountInput.addEventListener('input', updateTotal);
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (submitButton.disabled) return;
    const amount = sanitizeAmount(amountInput.value);
    checks.forEach(input => markInvalid(input, !input.checked));
    if (!amount) {
      showError(error.dataset?.invalid || 'Enter the whole-dollar total confirmed with Elena.', amountInput);
      return;
    }
    if (!confirmation.checked) {
      showError(error.dataset?.unconfirmed || 'Please confirm that Elena has approved this total.', confirmation);
      return;
    }
    if (policyConfirmation && !policyConfirmation.checked) {
      showError('Please read and agree to the Custom Order Policy.', policyConfirmation);
      return;
    }
    const variantId = form.dataset.variantId || form.querySelector('[name="id"]')?.value;
    if (!/^\d+$/.test(variantId || '')) {
      showError('Checkout is currently unavailable. Please contact Elena.', null);
      return;
    }
    const cartPath = form.dataset.cartUrl || (window.Shopify?.routes?.root || '/') + 'cart';
    const checkoutUrl = new URL(cartPath.replace(/\/$/, '') + '/' + variantId + ':' + amount, window.location.origin);
    error.textContent = '';
    errorTarget = null;
    submitButton.disabled = true;
    window.location.assign(checkoutUrl.href);
  });
  window.addEventListener('pageshow', () => { submitButton.disabled = false; });
})();
